class GoogleTagManagerWrapper {
    constructor() {
        window.dataLayer = window.dataLayer || [];
        this.landingPageId = null;
        this.product = null;
    }

    sendDefaultConsentSignal(defaultConsent) {
        if (!window.gtag) {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function () {
                window.dataLayer.push(arguments);
            };
        }
        window.gtag("consent", "default", defaultConsent);
    }

    updateConsent(consentValues) {
        if (!window.gtag) {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function () {
                window.dataLayer.push(arguments);
            };
        }
        window.gtag("consent", "update", consentValues);
    }

    checkForProduct(log) {
        if (!this.product || !this.landingPageId) {
            //eslint-disable-next-line no-console
            if (log) console.error('GTM: ProductId or LandingPageId not set', this.productId, this.landingPageId);
            return false;
        }
        return true;
    }

    consentGoogleAnalytics() {
        if (window.dataLayer.filter((entry) => {return entry.event === 'consentGoogleAnalytics'}).length > 0) {
            return;
        }
        window.dataLayer.push({
            'event': 'consentGoogleAnalytics',
            'consentGoogleAnalytics': 'true'
        });
        window.dataLayer.push({
            'event': 'consentGoogleAds',
            'consentGoogleAds': 'true'
        });
        window.dataLayer.push({
            'event': 'consentFacebook',
            'consentFacebook': 'true'
        });
    }
   colorChosed(selectedColor) {
        window.dataLayer.push({
            'event': 'choose_box_color',
            'box_color': selectedColor
        });
    }


    login(user_id) {
        window.dataLayer.push({
            'event': 'login',
            'user_id': user_id
        });
    }


    registration(user_id) {
        window.dataLayer.push({
            'event': 'registration',
            'user_id': user_id
        });
    }

    checkoutOption(step, option) {
        if (!this.checkForProduct(true)) return;
        window.dataLayer.push({
            'event': 'checkoutOption',
            'ecommerce': {
                'checkout_option': {
                    'actionField': { 'step': step, 'option': option }
                }
            }
        });
    }

    checkout(step, option) {
        if (!this.checkForProduct(true)) return;
        let actionField = {};
        actionField.step = step;
        if (option) {
            actionField.option = option;
        }
        window.dataLayer.push({
            'event': 'checkout',
            'ecommerce': {
                'checkout': {
                    'actionField': actionField,
                    'products': [this.product]
                }
            }
        });

    }

    /**
     * Sendet ein benutzerdefiniertes Event an den Google Tag Manager dataLayer.
     * Diese Funktion ist für generische Events gedacht und folgt der flachen
     * Key-Value-Struktur, die von GA4 erwartet wird.
     *
     * @param {string} name - Der Name des Events (z.B. 'login', 'page_view').
     * @param {Object} [params={}] - Ein Objekt mit den Event-Parametern.
     */
    event(name, params = {}) {
        // Stellt sicher, dass der dataLayer existiert.
        window.dataLayer = window.dataLayer || [];

        // Sendet das Event-Objekt an den dataLayer.
        // Die Struktur { 'event': name, ...params } ist das Standardformat für GA4.
        window.dataLayer.push({
            'event': name,
            ...params
        });
    }

    addToCart() {
        window.dataLayer.push({
            'event': 'addToCart',
            'ecommerce': {
                'add': {
                    'products': [this.product]
                }
            }
        });
    }

    removeFromCart() {
        window.dataLayer.push({
            'event': 'removeFromCart',
            'ecommerce': {
                'remove': {
                    'products': [this.product]
                }
            }
        });
    }

    translatePeriod(quantity, unit) {
        if (quantity != null && unit != null) {
            if (unit === 'day') {
                return quantity > 1 ? quantity + " Tage" : "1 Tag";
            } else if (unit === 'week') {
                return quantity > 1 ? quantity + " Wochen" : "1 Woche";
            } else if (unit === 'month') {
                return quantity > 1 ? quantity + " Monate" : "1 Monat";
            } else if (unit === 'year') {
                return quantity > 1 ? quantity + " Jahre" : "1 Jahr";
            } else {
                return "";
            }
        } else {
            return "";
        }
    }

    noPurchase() {
        if (this.checkForProduct()) {
            this.removeFromCart();
        }
        this.product = null;
        this.landingPageId = null;
    }

    addTopic(titleName) {
        window.dataLayer.push({
            event: 'add_topic',
            title_name: titleName,
        });
    }

    removeTopic(titleName) {
        window.dataLayer.push({
            event: 'remove_topic',
            title_name: titleName,
        });
    }

    addHero(titleName) {
        window.dataLayer.push({
            event: 'add_hero',
            title_name: titleName,
        });
    }

    removeHero(titleName) {
        window.dataLayer.push({
            event: 'remove_hero',
            title_name: titleName,
        });
    }

    addSeries(titleName) {
        window.dataLayer.push({
            event: 'add_series',
            title_name: titleName,
        });
    }

    removeSeries(titleName) {
        window.dataLayer.push({
            event: 'remove_series',
            title_name: titleName,
        });
    }

    addCluster(titleName) {
        window.dataLayer.push({
            event: 'add_cluster',
            title_name: titleName,
        });
    }
    removeCluster(titleName) {
        window.dataLayer.push({
            event: 'remove_cluster',
            title_name: titleName,
        });
    }

    addWildcard(wildcards) {
        window.dataLayer.push({
            event: "add_wildcard",
            name: wildcards
        });
    }

    addWatchlist(title_name) {
        window.dataLayer.push({
            event: "add_watchlist",
            title_name: title_name
        });
    }

    removeWatchlist(title_name) {
        window.dataLayer.push({
            event: "remove_watchlist",
            name: title_name
        });
    }

    addTicket(duration) {
        window.dataLayer.push({
            event: "redeem_ticket",
            item_variant: duration
        });
    }

    userInfo(user_id) {
        window.dataLayer.push({
            event: "user_id",
            user_id:user_id
        });
    }

    /**
     * Sendet ein Event, wenn eine Promotion-/Aktionsseite (Registrierung oder Kauf-Redirect
     * mit Partner-Konfiguration) angezeigt wird, damit sich der Aufruf dieser Seiten in GA
     * anhand der Promotion und des zugehörigen PlanVariants wiederfinden lässt.
     *
     * @param {string} promotionName - Name bzw. Kennung der Promotion (z.B. Partner-Slug).
     * @param {string} [planVariantId] - PlanVariantId des mit der Promotion verknüpften Produkts.
     */
    promotionView(promotionName, planVariantId) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "view_promotion",
            promotion_name: promotionName,
            plan_variant_id: planVariantId
        });
    }

    shippingInfoEvent(purchaseData, contact) {
        const shippingType = purchaseData.billwerkProductName;

        window.dataLayer.push({
            event: "add_shipping_info",
            contact: {
                city: contact.city,
                country: contact.country
            },
            shipping_tier: shippingType
        });
    }

    paymentMethodChangedEvent(purchaseData, paymentMethod) {
        if (!purchaseData || typeof purchaseData !== "object") {
            console.error("GTM Error: purchaseData is missing or invalid", purchaseData);
            return;
        }

        const paymentData = purchaseData.payment || {};
        const currency = purchaseData.currency || paymentData.currency || "EUR";

        window.dataLayer.push({
            event: "add_payment_info",
            ecommerce: {
                currency: currency,
                payment_type: paymentMethod
            }
        });
    }

    beginCheckoutEvent(purchaseData) {
        if (!purchaseData || !purchaseData.planVariantId) {
            return;
        }

        let planVariant = purchaseData.premiumAccessFeature._embedded.planVariant;
        let planGroup = purchaseData.premiumAccessFeature._embedded.planGroup;

        const durationValue = planVariant.BillingPeriod.quantity + " " + planVariant.BillingPeriod.unit
        const value = planVariant.BillingPeriod.quantity * planVariant.RecurringFee;
        const price = planVariant.RecurringFee;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: "begin_checkout",
            ecommerce: {
                currency: planGroup.Currency || "EUR",
                value: value,
                items: [{
                    item_id: purchaseData.planVariantId,
                    item_name: purchaseData.premiumAccessFeature.iap,
                    item_variant: durationValue,
                    price: price,
                    quantity: planVariant.BillingPeriod.quantity,
                }]
            }
        });
    }

    purchaseEvent(purchaseData) {
        if (!purchaseData || !purchaseData.planVariantId) {
            return;
        }
        //prevent duplicated events
        if (window.dataLayer.filter((entry) => {return entry.event === 'purchase'}).length > 0) {
            return;
        }

        let planVariant = purchaseData.premiumAccessFeature._embedded.planVariant;
        let planGroup = purchaseData.premiumAccessFeature._embedded.planGroup;

        const durationValue = planVariant.BillingPeriod.quantity + " " + planVariant.BillingPeriod.unit
        const value = planVariant.BillingPeriod.quantity * planVariant.RecurringFee;
        const price = planVariant.RecurringFee;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: "purchase",
            ecommerce: {
                transaction_id: purchaseData.orderId,
                currency: planGroup.Currency || "EUR",
                value: value,
                tax: purchaseData.tax || "19%",
                items: [{
                    item_id: purchaseData.planVariantId,
                    item_name: purchaseData.premiumAccessFeature.iap,
                    item_variant: durationValue,
                    price: price,
                    quantity: planVariant.BillingPeriod.quantity,
                }]
            }
        });
    }
}

let gtmw = new GoogleTagManagerWrapper();
export default gtmw;